module.exports = __webpack_public_path__ + "static/lighting-table-selected-row-0f504dc8e58caf08114dfbe22f0fb124.png";